<form *ngIf="fields.length" [formGroup]="formGroup" fxFlex>
  <ng-content></ng-content>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    <ng-container *ngFor="let field of fields">
      <mat-form-field fxFlex="calc(50% - 10px)" *ngIf="field.key">
        <mat-label>{{ field.name }}</mat-label>
        <ng-container [ngSwitch]="field.type">
          <mat-select *ngSwitchCase="CUSTOM_FIELD_TYPE.BOOLEAN" [formControlName]="field.key">
            <mat-option [value]="null">Not Set</mat-option>
            <mat-option [value]="true">True</mat-option>
            <mat-option [value]="false">False</mat-option>
          </mat-select>
          <input *ngSwitchCase="CUSTOM_FIELD_TYPE.STRING" matInput type="text" [formControlName]="field.key">
          <input *ngSwitchCase="CUSTOM_FIELD_TYPE.NUMBER" matInput type="number" [formControlName]="field.key">
          <input *ngSwitchCase="CUSTOM_FIELD_TYPE.DATE" matInput type="date" [formControlName]="field.key">
          <input *ngSwitchCase="CUSTOM_FIELD_TYPE.DATETIME" matInput type="datetime-local" [formControlName]="field.key">
          <ng-container *ngSwitchCase="CUSTOM_FIELD_TYPE.DROPDOWN">
            <mat-select [formControlName]="field.key" [multiple]="field.settings?.dropdownMultiple">
              <mat-option
                *ngFor="let option of field.settings?.dropdownOptions"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </ng-container>
        </ng-container>
        <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>
      </mat-form-field>
    </ng-container>
  </div>
</form>
